export const sideMenuActions = {
  GET_SIDEMENU_LIST: 'GET_SIDEMENU_LIST',
  SET_SIDEMENU_STATE: 'SET_SIDEMENU_STATE',
  UPDATE_SIDEMENU_STYLE: 'UPDATE_SIDEMENU_STYLE',
  SEND_ANALYTICS_DATA: 'SEND_ANALYTICS_DATA',
  GET_DASHBOARD_URL: 'GET_DASHBOARD_URL',
  SIDE_MENU_TEST: 'SIDE_MENU_TEST'
};

export const getSideMenuListAction = sideMenuConfigObj => ({
  type: sideMenuActions.GET_SIDEMENU_LIST,
  payload: sideMenuConfigObj
});

export const setSideMenuStateAction = obj => ({
  type: sideMenuActions.SET_SIDEMENU_STATE,
  payload: obj
});

export const updateSideMenuStyleAction = stateObj => ({
  type: sideMenuActions.UPDATE_SIDEMENU_STYLE,
  payload: stateObj
});

export const sendAnalyticsDataAction = analyticsData => ({
  type: sideMenuActions.SEND_ANALYTICS_DATA,
  payload: analyticsData
});
